module.exports = __webpack_public_path__ + "img/Cuadro_MAMO_VIOLA_Titulo.2f9bb5ad.jpg";